export let DocumentType = /*#__PURE__*/function (DocumentType) {
  DocumentType["TERMS_AND_CONDITIONS"] = "terms-and-conditions";
  DocumentType["PRIVACY_POLICY"] = "privacy-policy";
  return DocumentType;
}({});